import React, { useState } from 'react';
import { useWorkspace } from '../../context/WorkspaceContext';
import { Modal } from '../../design-system/Modal';
import { Input } from '../../design-system/Input';
import { Select } from '../../design-system/Dropdown';
import { Button } from '../../design-system/Button';
import { Mail, Send, ShieldCheck } from 'lucide-react';

export const InviteMemberModal = ({ isOpen, onClose }) => {
  const { inviteMember, activeWorkspace } = useWorkspace();
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('member');
  const [error, setError] = useState('');

  const roleOptions = [
    { value: 'admin', label: 'Admin (Manage projects, modules & team settings)' },
    { value: 'member', label: 'Member (Create & edit tasks, view modules)' },
    { value: 'guest', label: 'Guest (View only assigned projects & tasks)' }
  ];

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (!email.trim() || !email.includes('@')) {
      setError('Please enter a valid email address.');
      return;
    }

    inviteMember(email.trim(), role);
    setEmail('');
    setRole('member');
    setError('');
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Invite Team Member"
      subtitle={`Invite a new collaborator to ${activeWorkspace?.name}`}
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit} icon={<Send size={15} />}>
            Send Invitation
          </Button>
        </>
      }
    >
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <Input
          label="Email Address *"
          type="email"
          placeholder="colleague@company.com"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            if (error) setError('');
          }}
          icon={<Mail size={16} />}
          error={error}
          autoFocus
          required
        />

        <Select
          label="Assigned Role *"
          options={roleOptions}
          value={role}
          onChange={setRole}
        />

        <div
          style={{
            padding: '12px 14px',
            backgroundColor: 'var(--surface-recessed)',
            borderRadius: 'var(--radius-md)',
            border: '1px solid var(--border-subtle)',
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }}
        >
          <ShieldCheck size={18} color="var(--accent-teal)" />
          <span style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>
            Invitations expire in 7 days. Role permissions can be modified anytime in workspace settings.
          </span>
        </div>
      </form>
    </Modal>
  );
};
